// Reproduces the console signature of a wallet browser extension (MetaMask
// and lookalikes) failing to connect: a bare "inpage.js" stack frame, thrown
// both as an uncaught exception and as an unhandled promise rejection - the
// same two paths isExtensionInjectedError() filters in browserInstrumentation.js.
// Use this to confirm the filter is working: with the fix in place neither
// throw below should open the fatal recovery popup.
function buildFakeExtensionError(message) {
  const error = new Error(message);

  error.stack = `Error: ${message}\n    at Object.connect (inpage.js:7:84292)\n    at inpage.js:4:42708`;

  return error;
}

export const triggerTestExtensionError = () => {
  setTimeout(() => {
    throw buildFakeExtensionError('Failed to connect to MetaMask');
  }, 0);

  Promise.reject(buildFakeExtensionError('Failed to connect to MetaMask'));
};
